const imgUrl = [
  require('../../../assets/img/AIDetect/detece/AI (1).png'),
  require('../../../assets/img/AIDetect/detece/AI (2).png'),
  require('../../../assets/img/AIDetect/detece/AI (3).png'),
  require('../../../assets/img/AIDetect/detece/AI (4).png'),
  require('../../../assets/img/AIDetect/detece/AI (5).png'),
  require('../../../assets/img/AIDetect/detece/AI (6).png'),
];

export default imgUrl;
